// @flow

import type { FormErrors } from '@globalTypes';

import type { PersonalData } from '../types';

import {
  PERSONAL_DATA_REQUEST,
  PERSONAL_DATA_REQUESTED_SUCCESS,
  PERSONAL_DATA_REQUESTED_ERROR,
  PERSONAL_DATA_FORM_UPDATE,
  PERSONAL_DATA_FORM_ERROR,
  PERSONAL_DATA_FORM_SUCCESS,
  PERSONAL_DATA_FORM_RESET,
  PERSONAL_DATA_FIRST_LOAD,
  OPEN_CV_PREVIEW
} from './constants';

import type {
  GetAction, UpdateAction, ResetAction, FirstLoadAction
} from './types';

export const requestPersonalData = (): GetAction => ({
  type: PERSONAL_DATA_REQUEST
});

export const successRequestPersonalData = (data: PersonalData, opinion: any): GetAction => {
  const myData = { ...data };
  myData.opinion = [...opinion];
  return {
    type: PERSONAL_DATA_REQUESTED_SUCCESS,
    data: myData
  };
};

export const errorRequestPersonalData = (error: Error): GetAction => ({
  type: PERSONAL_DATA_REQUESTED_ERROR,
  error
});

export const updatePersonalDataForm = (id: string, data: {}): UpdateAction => ({
  type: PERSONAL_DATA_FORM_UPDATE,
  data,
  id
});

export const successPersonalDataForm = (id: string): UpdateAction => ({
  type: PERSONAL_DATA_FORM_SUCCESS,
  id
});

export const errorPersonalDataForm = (id: string, error: FormErrors): UpdateAction => ({
  type: PERSONAL_DATA_FORM_ERROR,
  error,
  id
});

export const resetPersonalDataForm = (id: string): ResetAction => ({
  type: PERSONAL_DATA_FORM_RESET,
  id
});

export const firstLoadPersonalData = (): FirstLoadAction => ({
  type: PERSONAL_DATA_FIRST_LOAD
});

export const openCvPreview = () => ({
  type: OPEN_CV_PREVIEW
});
